import { Component, inject, Input, OnInit } from '@angular/core';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { IndicatorData } from '../../../models/indicator-data';
import { DataLayer } from '../../../models/data-layer';
import { IndicatorDetailButtonComponent } from '../../atoms/indicator-detail-button/indicator-detail-button.component';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-data-layer-data-list',
  standalone: true,
  imports: [IndicatorDetailButtonComponent, AlertComponent, NgClass],
  templateUrl: './data-layer-data-list.component.html',
  styleUrl: './data-layer-data-list.component.scss',
})
export class DataLayerDataListComponent implements OnInit {
  readonly indicatorDataStore = inject(IndicatorDataStore);
  readonly indicatorStore = inject(IndicatorStore);
  dataInLayer: IndicatorData[] = [];
  @Input() dataLayer!: DataLayer;

  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * Performs initialization logic by filtering indicator data associated with the specified data layer.
   *
   * @return {void} No return value.
   */
  ngOnInit(): void {
    this.dataInLayer = this.indicatorDataStore.filterByDataLayer(
      this.dataLayer._id
    );
  }
}
